<!--
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2021-12-17 09:57:14
 * @LastEditTime: 2022-05-05 17:49:53
 * @Description: 邮件账号列表
-->
<template>
  <general-layout>
    <template #header>
      <east-operate>
        <template #left>
          <el-button
            size="small"
            type="primary"
            @click="CreateReport"
            :disabled="downloading"
          >
            生成列表
          </el-button>

          <el-button
            size="small"
            type="primary"
            @click="exportExcel"
            :disabled="downloading"
          >
            导出列表
          </el-button>
        </template>
        <template #right>
          <el-select
            v-model="state"
            @change="currentPage = 1"
            size="mini"
            style="width: 104px;margin-left:7px;"
          >
            <el-option value="" label="全部状态"></el-option>
            <el-option value="正常" label="正常"></el-option>
            <el-option value="禁用" label="禁用"></el-option>
          </el-select>
          <el-select
            v-model="syncSetting"
            @change="currentPage = 1"
            size="mini"
            style="width: 154px;margin-left:7px;"
          >
            <el-option value="" label="全部同步设置"></el-option>
            <el-option value="同步" label="同步"></el-option>
            <el-option value="不同步" label="不同步"></el-option>
          </el-select>
          <el-select
            v-model="sync"
            @change="currentPage = 1"
            size="mini"
            style="width: 154px;margin-left:7px;"
          >
            <el-option value="" label="全部同步状态"></el-option>
            <el-option value="已同步" label="已同步"></el-option>
            <el-option value="--" label="未同步"></el-option>
          </el-select>
          <el-input
            placeholder="请输入邮箱/姓名关键字"
            size="mini"
            v-model="keyword"
            clearable
          >
            <el-input
              size="small"
              class="input-keyword"
              v-model="keyword"
              placeholder="查找邮箱"
              :spellcheck="false"
              autocomplete="off"
              @input="currentPage = 1"
            />
            <!-- <el-button
              type="primary"
              icon="el-icon-search"
              size="mini"
              title="搜索邮箱"
              @click="fetchData"
              slot="append"
            ></el-button> -->
          </el-input>
        </template>
      </east-operate>
    </template>
    <el-table :empty-text="emptyText" :data="tableData" v-loading="loading">
      <el-table-column prop="dn" label="DN" min-width="300"></el-table-column>
      <el-table-column
        prop="samAccountName"
        label="SAMAccountName"
        width="200"
        v-if="isshowsaccount"
      ></el-table-column>
      <el-table-column
        prop="userPrincipalName"
        label="UPN"
        width="200"
        v-if="isshowsaccount"
      ></el-table-column>
      <el-table-column
        prop="mail"
        label="邮箱"
        width="230"
        sortable
      ></el-table-column>
      <el-table-column
        prop="displayName"
        label="显示名称"
        width="200"
      ></el-table-column>
      <el-table-column prop="state" label="状态" width="140" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.state === '正常'" class="text-success"
            >正常</span
          >
          <span v-else class="text-danger">禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="syncSetting"
        label="同步设置"
        width="100"
        sortable
      ></el-table-column>

      ><el-table-column prop="sync" label="同步状态" width="100" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.sync === '已同步'" class="text-success">{{
            scope.row.sync
          }}</span>
          <span v-else>{{ scope.row.sync }}</span>
        </template></el-table-column
      >

      <!-- <el-table-column prop="createTime" label="创建时间" width="200" sortable
        ><template slot-scope="scope">
          {{ scope.row.createTime }}
        </template></el-table-column
      > -->

      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleView(scope.row.dn)"
            >明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 200, 500]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="allData.length"
      >
      </el-pagination>
    </template>
    <!-- 明细 开始 -->

    <el-dialog title="节点属性设置" :visible.sync="editorVisible" width="800px">
      <entry-editor
        v-if="editorVisible"
        :dn="editDn"
        :is-add="isAdd"
        :schema-name="editSchemaName"
        @complete="editorVisible = false"
      ></entry-editor>
    </el-dialog>
    <!-- 明细 结束 -->
  </general-layout>
</template>
<script>
import UTIL from "@/api/sync/util";
import LDAP from "@/api/sync/ldap";

import EntryEditor from "@/pages/ldap/entry-editor";

export default {
  name: "app",
  data() {
    return {
      config: { accountlist: [] },
      editLabelWidth: "70px",
      keyword: "",
      state: "",
      sync: "",
      syncSetting: "",
      pageSize: 50,
      currentPage: 1,
      downloading: false,
      mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      action: process.env.VUE_APP_API_URL + "parseexcel",
      viewShow: false,
      viewData: {},
      emptyText: "暂无数据! ",
      loading: false,
      dn: "",
      adkeyword: "",
      editorVisible: false,
      isAdd: false,
      editDn: "",
      isshowsaccount: false
    };
  },
  computed: {
    allData() {
      //console.log("this.state:" + this.state);
      //console.log("this.time:" + this.time + "this.time[0]:" + this.time[0]);
      if (this.state != "" && this.syncSetting == "" && this.sync == "") {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.state.includes(this.state)
        );
      } else if (
        this.state != "" &&
        this.syncSetting != "" &&
        this.sync == ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.state.includes(this.state) &&
            maillist.syncSetting == this.syncSetting
        );
      } else if (
        this.state != "" &&
        this.syncSetting != "" &&
        this.sync != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.state.includes(this.state) &&
            maillist.syncSetting == this.syncSetting &&
            maillist.sync.includes(this.sync)
        );
      } else if (
        this.state != "" &&
        this.syncSetting == "" &&
        this.sync != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.state.includes(this.state) &&
            maillist.sync.includes(this.sync)
        );
      } else if (
        this.state != "" &&
        this.syncSetting != "" &&
        this.sync == ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.state.includes(this.state) &&
            maillist.syncSetting == this.syncSetting
        );
      } else if (
        this.state == "" &&
        this.syncSetting != "" &&
        this.sync == ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.syncSetting==this.syncSetting
        );
      } else if (
        this.state == "" &&
        this.syncSetting == "" &&
        this.sync != ""
      ) {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword)) &&
            maillist.sync.includes(this.sync)
        );
      } else {
        return this.config.accountlist.filter(
          maillist =>
            maillist.mail != "" &&
            (maillist.mail.includes(this.keyword) ||
              maillist.dn.includes(this.keyword) ||
              maillist.displayName.includes(this.keyword))
          //&&  maillist.state.includes(this.state) &&
          // maillist.syncSetting.includes(this.syncSetting) &&
          // maillist.sync.includes(this.sync)
        );
      }
    },
    tableData() {
      return this.allData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    }
  },
  components: { EntryEditor },
  async created() {
    //this.config.accountlist = await this.fetchData("", "");
  },
  methods: {
    async CreateReport() {
      try {
        await this.$confirm("确定生成本地邮箱列表,确认?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        });
        this.loading = true;
        this.downloading = true;
        this.config.accountlist = await this.fetchData("", "");
        this.loading = false;
        this.downloading = false;
        // eslint-disable-next-line no-empty
      } catch {
        this.loading = false;
        return;
      }
    },
    handleView(dn) {
      this.isAdd = false;
      this.editDn = dn;
      this.editorVisible = true;
    },
    async fetchData(dn, adkeyword) {
      try {
        let response = await LDAP.ExportENTRY_UserLIST({ dn, adkeyword });

        if (response.data.state) {
          this.loading = false;
          console.log(response.data.entries_list);
          console.log(response.data.isshowsaccount);
          this.isshowsaccount = response.data.isshowsaccount;
          return response.data.entries_list;
        } else {
          this.loading = false;
          this.emptyText = "接口异常本地邮箱列表获取失败";
          return [];
        }
      } catch (e) {
        this.loading = false;
        this.$message.error("接口异常本地邮箱列表获取失败." + e);
      }
      return [];
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    createExcel(isshowsaccount) {
      if (isshowsaccount) {
        let excel = [
          [
            "DN",
            "SAMAccountName",
            "UPN",
            "显示名称",
            "邮箱",
            "账号状态",
            "同步设置",
            "同步状态"
          ]
        ];
        this.allData.forEach(row =>
          excel.push([
            row.dn,
            row.samAccountName,
            row.userPrincipalName,
            row.displayName,
            row.mail,
            row.state,
            row.syncSetting,
            row.sync
          ])
        );
        return excel;
      } else {
        let excel = [
          ["DN", "显示名称", "邮箱", "账号状态", "同步设置", "同步状态"]
        ];
        this.allData.forEach(row =>
          excel.push([
            row.dn,
            row.displayName,
            row.mail,
            row.state,
            row.syncSetting,
            row.sync
          ])
        );
        return excel;
      }
    },
    async exportExcel() {
      if (!this.downloading) {
        this.downloading = true;
        let loading = this.$loading({
          lock: true,
          text: "本地邮箱列表下载中, 请稍后!",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        try {
          /*  let res = await this.$http.post("genexcel", this.createExcel(), {
            responseType: "blob"
          });
           */
          let res = await UTIL.GENEXCEL(this.createExcel(this.isshowsaccount));
          let a = document.createElement("a");
          a.download = "本地邮箱列表.xlsx";
          a.href = URL.createObjectURL(res.data);
          a.click();
        } catch (e) {
          loading.close();
          this.$message.error("本地邮箱列表导出失败。");
        } finally {
          this.downloading = false;
          loading.close();
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 200px;
  margin: 0 8px;
}
.custom-dialog {
  table {
    width: 100%;
    tr {
      line-height: 36px;
      td:first-child {
        width: 70px;
      }
    }
  }
}
</style>
